import abstractRes from '../common/abstract.resource';
import {readAuthMethod} from './auth_method.serializer';

const mod = angular.module('app.tupas.tupasResource', [abstractRes])

.factory('AuthMethodResource', function ($q, $http, AbstractResource) {
  class AuthMethodResource extends AbstractResource {
    constructor() {
      super('auths/authmethods', o => o, true);
    }

    getOne() {
      return $q.reject('Use getMethodDetails() method');
    }

    getMany(filters={}, mapper=(o => AuthMethodResource._manyMapper(o))) {
      return super.getMany(filters, mapper);
    }

    getAll(mapper=(o => AuthMethodResource._manyMapper(o))) {
      return super.getAll(mapper);
    }

    // Map data returned from getMany/getAll to minimal bank representation
    static _manyMapper(o) {
      return readAuthMethod(o).makeImmutable();
    }
  }

  return new AuthMethodResource();
});

export default mod.name;
